/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-indent */
/* eslint-disable prefer-template */
import * as React from "react";

import {
  Avatar,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  makeStyles,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import clsx from "clsx";
import { toast } from "react-toastify";

import CommentOKDialog from "./CommentOKDialog";
import BeforeSendDialog from "./BeforeSendDialog";
import AgapeIcon from "../../../../../../common/icons/AgapeIcon";
import { postOrganizationComment } from "../../../../../../../services/AgapeAPI";
import RoundButton from "../../../../../../common/button/RoundButton";
import { useSelector } from "react-redux";
import { me } from "../../../../../../../redux/slices/me";

const useStyles = makeStyles((theme) => ({
  root__form: {
    width: "100%",
    maxWidth: "100%",
  },
  formContainer: {
    maxWidth: "100%",
  },
  textField: {
    borderRadius: "5px",
    height: "100%",
    "& .MuiInputBase-root": {
      borderRadius: "5px",
      border: "2px solid #ededed",
    },
  },
  fieldsContainer: {
    marginBottom: "10px",
  },
  commentField: {
    height: "200px",
    position: "realative",
    "& .MuiInputBase-root": {
      height: "200px !important",
    },
    "& textarea": {
      position: "absolute",
      overflowY: "visible !important",
      height: "90% !important",
      width: "98% !important",
      right: "1%",
      left: "1%",
      margin: "auto !important",
    },
  },
  send: {
    marginLeft: "auto",
  },
  box2Container: {
    margin: "auto",
  },
  profContainer: {
    borderRadius: "50%",
    boxShadow: "0 7px 31px 0 rgb(0 0 0 / 16%)",
    margin: "20px 0",
    maxWidth: "100px",
    aspectRatio: "1",

    "& .MuiAvatar-root": {
      width: "100%",
      height: "100%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "50px",
    },
  },
  profImg: {
    maxWidth: "80px",
    height: "80px",
    padding: "10px",
  },
  username: {
    marginLeft: "10px",
    "& p": {
      fontSize: "1.636rem !important",
      color: "black",
      fontWeight: "bold",
      opacity: "0.7",
    },
  },
  legend: {
    fontWeight: "bold",
  },
  iconBtn: {
    padding: 5,
    border: "1px solid #00000050",
    borderRadius: "5px",
  },
  marginTop: {
    marginTop: "20px",
  },
  singleItem: {
    position: "relative",
    fontFamily: "VazirFD",
    fontSize: "1.4rem !important",
    paddingRight: "35px !important",
    textAlign: "justify",
  },
  fieldContainer: {
    alignSelf: "flex-start",
  },
  optionUL: {
    listStyleType: "none",
    padding: "0",
  },
  negativeItem: {
    backgroundColor: "#f5365c1a",
    "&:not(:last-child)": {
      marginBottom: "10px",
    },
    padding: "10px",
    borderRadius: "6px",
    color: theme.palette.error.main,
  },
  positiveItem: {
    backgroundColor: "#30c0b01a",
    "&:not(:last-child)": {
      marginBottom: "10px",
    },
    padding: "10px",
    borderRadius: "6px",
    color: theme.palette.success.main,
  },
  removeItemBtn: {
    position: "absolute",
    right: "11px",
    top: "5px",
  },
  requiredField: {
    color: theme.palette.error.main,
  },
}));

const UserCreateComment = ({ code, ...props }) => {
  const theme = useTheme();
  const classes = useStyles();

  const userData = useSelector(me);

  const [positives, setPositives] = React.useState([]);
  const [negatives, setNegatives] = React.useState([]);
  const [positiveField, setPositiveField] = React.useState();
  const [negativeField, setNegativeField] = React.useState();
  const [description, setDescription] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openReady, setOpenReady] = React.useState(false);
  const [readyToSendComment, setReadyToSendComment] = React.useState(false);

  React.useEffect(() => {
    async function sendCommentToServer() {
      if (readyToSendComment) {
        setLoading(true);
        postOrganizationComment(code, {
          content: description,
          negative: negatives.join(","),
          positive: positives.join(","),
        })
          .then((response) => {
            setOpen(true);
            setPositives([]);
            setNegatives([]);
            setDescription("");
          })
          .catch((err) => {
            toast.error("پر کردن فیلد توضیحات اجباری است", {
              position: "bottom-left",
            });
          })
          .finally(() => {
            setLoading(false);
            setReadyToSendComment(false);
          });
      }
    }

    sendCommentToServer();
  }, [readyToSendComment]);

  const handleAddNegative = () => {
    if (negativeField.length > 0) {
      setNegatives([...negatives, negativeField]);
      setNegativeField("");
    }
  };

  const handleAddPositive = () => {
    if (positiveField.length > 0) {
      setPositives([...positives, positiveField]);
      setPositiveField("");
    }
  };

  const handleFormSubmit = () => {
    setOpenReady(true);
  };

  const handlePositiveFieldChange = (e) => {
    setPositiveField(e.target.value);
  };

  const handleNegativeFieldChange = (e) => {
    setNegativeField(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleNegativeKeyDown = (e) => {
    if (e.which === 13) {
      handleAddNegative();
    }
  };

  const handlePositiveFieldKeyDown = (e) => {
    if (e.which === 13) {
      handleAddPositive();
    }
  };

  const handleNegativeRemove = (index) => {
    setNegatives([...negatives.filter((nItem, nIndex) => nIndex !== index)]);
  };

  const handlePositiveRemove = (index) => {
    setPositives([...positives.filter((pItem, pIndex) => pIndex !== index)]);
  };

  return (
    <div className={classes.root__form}>
      <CommentOKDialog
        open={open}
        setOpen={setOpen}
        title="نظر شما ثبت شد"
        subtitle={
          <>
            نظر شما ثبت شد و پس از بررسی کارشناسان ما، منتشر و
            <br /> به شما اطلاع رسانی خواهد شد.
          </>
        }
      />

      <BeforeSendDialog
        setReadyToSend={setReadyToSendComment}
        open={openReady}
        setOpen={setOpenReady}
        title="آیا از ثبت دیدگاه خود اطمینان دارید؟"
      />

      <form onSubmit={handleFormSubmit} className={classes.formContainer}>
        <Grid
          container
          justifyContent="space-between"
          justify="center"
          alignItems="center"
          className={classes.formContainer}
        >
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={11}
            justify="space-between"
            alignItems="center"
            className={classes.fieldsContainer}
          >
            <Grid item container alignItems="center" xs={12} sm={12} md={12}>
              <Grid item xs sm md className={classes.profContainer}>
                <Avatar alt="عکس پروفایل کاربر" src={userData?.avatar} />
              </Grid>
              <Grid item md className={classes.username}>
                <Typography>
                  {`${userData?.first_name || ""} ${userData?.last_name || ""}`}
                  {userData?.first_name === null && userData?.last_name === null
                    ? "کاربر گرامی"
                    : ""}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={5}
              className={classes.fieldContainer}
            >
              <Grid item md={12}>
                <Typography className={classes.legend}>نقاط قوت</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  name="pros"
                  variant="outlined"
                  fullWidth
                  placeholder="نقطه قوت را بنویسید"
                  value={positiveField}
                  onChange={handlePositiveFieldChange}
                  onKeyDown={handlePositiveFieldKeyDown}
                  className={classes.textField}
                  InputProps={{
                    endAdornment: positiveField?.length > 0 && (
                      <IconButton className={classes.iconBtn}>
                        <AgapeIcon
                          icon="plus"
                          size="1.2rem"
                          color="#00000070"
                          onClick={handleAddPositive}
                        />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <ul className={classes.optionUL}>
                  {positives.map((pos, itemIndex) => (
                    <li
                      key={pos}
                      className={clsx(classes.singleItem, classes.positiveItem)}
                    >
                      <IconButton
                        onClick={() => handlePositiveRemove(itemIndex)}
                        className={classes.removeItemBtn}
                      >
                        <AgapeIcon
                          icon="close"
                          size="0.9rem"
                          color={theme.palette.success.main}
                        />
                      </IconButton>
                      {pos}
                    </li>
                  ))}
                </ul>
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={5}
              className={classes.fieldContainer}
            >
              <Grid item md={12}>
                <Typography className={classes.legend}>نقاط ضعف</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  name="cons"
                  value={negativeField}
                  variant="outlined"
                  fullWidth
                  placeholder="نقطه ضعف را بنویسید"
                  onChange={handleNegativeFieldChange}
                  onKeyDown={handleNegativeKeyDown}
                  className={classes.textField}
                  InputProps={{
                    endAdornment: negativeField?.length > 0 && (
                      <IconButton className={classes.iconBtn}>
                        <AgapeIcon
                          icon="plus"
                          size="1.2rem"
                          color="#00000070"
                          onClick={handleAddNegative}
                        />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <ul className={classes.optionUL}>
                  {negatives.map((neg, itemIndex) => (
                    <li
                      key={neg}
                      className={clsx(classes.singleItem, classes.negativeItem)}
                    >
                      <IconButton
                        onClick={() => handleNegativeRemove(itemIndex)}
                        className={classes.removeItemBtn}
                      >
                        <AgapeIcon
                          icon="close"
                          size="0.9rem"
                          color={theme.palette.error.main}
                        />
                      </IconButton>
                      {neg}
                    </li>
                  ))}
                </ul>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={11} className={classes.marginTop}>
            <Typography className={classes.legend}>
              دیدگاه شما <span className={classes.requiredField}>*</span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={11}
            className={classes.fieldsContainer}
          >
            <TextField
              name="description"
              variant="outlined"
              fullWidth
              multiline
              placeholder="دیدگاه خود را وارد کنید"
              value={description}
              onChange={handleDescriptionChange}
              className={clsx(classes.textField, classes.commentField)}
            />
          </Grid>
          <Grid item xs={12} md={11} container justify="flex-end">
            <Grid item xs={6} sm={6} md={2} className={classes.fieldsContainer}>
              <RoundButton
                fullWidth
                fontSize="1.318rem"
                onClick={handleFormSubmit}
                disabled={loading || description === ""}
              >
                {loading ? (
                  <CircularProgress size={31} color="white" />
                ) : (
                  "تایید"
                )}
              </RoundButton>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default UserCreateComment;
